import React from "react"
import { FormSpy, Field } from "react-final-form"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import Uploader from "src/features/Components/UploadWithButton"
import {
  required,
  isNumber,
  composeValidators,
} from "src/features/Utils/validate"
import CancelIcon from "@material-ui/icons/Cancel"
import Card from "./card"
import CommaPrice from "src/features/Utils/CommaPrice"

const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <Box mb={2}>
    <TextField
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
    />
  </Box>
)

function Index({ totalPrice = 0 }) {
  return (
    <FormSpy subscription={{ values: true, submitting: true }}>
      {({ values: { cover_img, medicine }, form: { mutators } }) => {
        return (
          <Box mt={3}>
            <Box bgcolor="white" px={3} py={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Box fontSize="16px" mb={2}>
                    Cover Image
                  </Box>
                  {cover_img && (
                    <Box position="relative">
                      <Box
                        mb={2}
                        component="img"
                        width="100%"
                        src={cover_img}
                      />
                      <Box
                        position="absolute"
                        right={0}
                        component={IconButton}
                        onClick={() => mutators.setImg("")}
                      >
                        <CancelIcon />
                      </Box>
                    </Box>
                  )}
                  <Uploader onUpload={(img) => mutators.setImg(img)} />
                  <Box mt={2}>
                    File Format: .JPG, .PNG | Ratio: 1:1 | Max: 5MB
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Box fontSize="16px" mb={2}>
                    Information
                  </Box>
                  <Field
                    name="name"
                    variant="outlined"
                    component={renderTextField}
                    InputLabelProps={{ shrink: true }}
                    label="Label Name *"
                    fullWidth
                    validate={required}
                  />
                  <Field
                    name="promo_price"
                    variant="outlined"
                    component={renderTextField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">฿</InputAdornment>
                      ),
                    }}
                    InputLabelProps={{ shrink: true }}
                    label="Bundle Total Price *"
                    fullWidth
                    validate={composeValidators(required, isNumber)}
                  />
                  <Field
                    name="detail"
                    variant="outlined"
                    component={renderTextField}
                    InputLabelProps={{ shrink: true }}
                    label="Description *"
                    validate={required}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Box>
            <Box mt={3} mb={3} display="flex" justifyContent="space-between">
              <div>Have {medicine.length} Package(s)</div>
              <div>Original total price: {CommaPrice(totalPrice)}</div>
            </Box>
            <Box overflow="auto" whiteSpace="nowrap">
              <Box minWidth="1184px">
                {medicine.map((item) => (
                  <Card key={item._id} item={item} />
                ))}
              </Box>
            </Box>
          </Box>
        )
      }}
    </FormSpy>
  )
}

export default Index
